import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { steps } from "../data/business";

export default function Process() {
    return (
        <section data-testid="process-section" className="bg-paper py-20 sm:py-28 lg:py-36">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow>Como funciona</Eyebrow>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Simples do primeiro
                        <span className="italic text-accent"> contato à entrega.</span>
                    </h2>
                </Reveal>

                <div className="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-6">
                    <div className="absolute left-[7px] top-2 h-[calc(100%-1rem)] w-px bg-line md:left-0 md:top-[7px] md:h-px md:w-full" />
                    {steps.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.12}>
                            <div className="relative pl-10 md:pl-0 md:pt-12">
                                <span className="absolute left-0 top-0 flex h-4 w-4 items-center justify-center md:top-0">
                                    <span className="h-3.5 w-3.5 rounded-full border border-accent bg-paper" />
                                </span>
                                <span className="font-display text-4xl font-light text-accent">
                                    {s.n}
                                </span>
                                <h3 className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-ink">
                                    {s.title}
                                </h3>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
